import React, { Component } from 'react';
import NavMenu from './NavMenu';
import Footer from './Footer';
import Styles from './layoutStyles.module.scss'
import DiscountReader from '../DiscountReader';
import Notification from '../Notification';
import ImpersonationBanner from '../ImpersonationBanner';
import SummerSalePeek from '../Heros/SummerSale/SummerSalePeek';

export class Layout extends Component {
    static displayName = Layout.name;

    constructor(props) {
        super(props);
        this.state = {
            showNavAndFooter: true,
        };
    }
    render() {
        return (
            <>
                <ImpersonationBanner />
                <Notification bannerMessage={this.props.bannerMessage} />
                <DiscountReader />
                {this.state.showNavAndFooter && <NavMenu />}
                <main tag="main" className={Styles.layout}>
                    {this.props.children}
                </main>
                <SummerSalePeek />
                {this.state.showNavAndFooter && <Footer />}
            </>
        );
    }
}